module.exports = __webpack_public_path__ + "img/svg/background-competition-ranked-card-mobile.b4fbafd299843eda678d45b444851a52.svg";